var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "#fff",
    stroke: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-drive_svg__clip0_1153_670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.268 30.257l1.323 2.214c.275.466.67.832 1.134 1.099 1.329-1.635 2.254-2.889 2.775-3.763.529-.886 1.179-2.274 1.95-4.161-2.078-.265-3.653-.398-4.725-.398-1.028 0-2.603.133-4.725.398 0 .516.137 1.032.412 1.498l1.856 3.113z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.275 33.57c.464-.267.86-.633 1.134-1.1l.55-.915 2.629-4.411c.27-.456.412-.973.412-1.498-2.134-.265-3.706-.398-4.716-.398-1.086 0-2.658.133-4.717.398.762 1.898 1.404 3.285 1.925 4.161.525.885 1.453 2.139 2.783 3.763z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16.323c1.538-1.799 2.597-3.186 3.179-4.161.468-.786.984-2.04 1.546-3.762A3.096 3.096 0 0026.18 8H19.82c-.55 0-1.082.15-1.546.4.716 1.975 1.323 3.381 1.822 4.218.55.924 1.519 2.16 2.903 3.705z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.55 25.646h-11.1l-4.725 7.925c.464.266.997.399 1.546.399H31.73c.55 0 1.082-.15 1.546-.4l-4.725-7.924z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16.324L18.275 8.4c-.464.267-.86.633-1.134 1.1L8.412 24.147c-.27.457-.412.973-.412 1.499h9.45L23 16.324z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.224 16.824l-4.365-7.325A3.072 3.072 0 0027.725 8.4L23 16.324l5.55 9.323h9.433c0-.516-.137-1.032-.412-1.498l-4.347-7.325z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-drive_svg__clip0_1153_670"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 8)",
    d: "M0 0h30v26H0z"
  })))));
}

export default SvgGoogleDrive;